import { render, staticRenderFns } from "./return-order-consolidation.vue?vue&type=template&id=537c6d10&"
import script from "./js/return-order-consolidation.js?vue&type=script&lang=js&"
export * from "./js/return-order-consolidation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports